(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-experience-stack"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const eventName = 'homepage_experience_interaction';

    const publish = (action, name, destination, onComplete) => {
      const placement = 'homepage_after_outdoor_living';
      const resolvedDestination = destination || '';
      const gaEventName = action === 'click'
        ? 'homepage_experience_click'
        : 'homepage_experience_impression';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        homepage_experience_action: action,
        homepage_experience_name: name,
        homepage_experience_destination: resolvedDestination,
        homepage_experience_placement: placement,
      homepage_experience_variant: name + '_primary'
      });

      if (typeof window.gtag === 'function') {
        const gaParameters = {
          send_to: 'G-7Y4XZ7ZGSS',
          homepage_experience_name: name,
          homepage_experience_placement: placement,
        homepage_experience_variant: name + '_primary',
          link_url: resolvedDestination
        };

        if (action === 'impression') {
          gaParameters.non_interaction = true;
        }

        if (action === 'click' && typeof onComplete === 'function') {
          gaParameters.event_callback = onComplete;
          gaParameters.event_timeout = 250;
          gaParameters.transport_type = 'beacon';
        }

        window.gtag('event', gaEventName, gaParameters);
      } else if (typeof onComplete === 'function') {
        onComplete();
      }

      document.dispatchEvent(new CustomEvent('rogers:homepage-experience', {
        detail: { action, name, destination: resolvedDestination },
        bubbles: true
      }));
    };

    const arrangeExperienceOrder = (section) => {
      const stackWrapper = section.closest('.shopify-section') || section.parentElement;
      const patio = document.querySelector('[data-patio-moments]');
      const patioWrapper = patio && (patio.closest('.shopify-section') || patio.parentElement);
      const seasonal = document.querySelector('[data-rg-seasonal-reasons]');
      const seasonalWrapper = seasonal && (seasonal.closest('.shopify-section') || seasonal.parentElement);
      const popularCategories = document.getElementById('shopify-section-1600453141623');

      if (seasonalWrapper && popularCategories && popularCategories.nextElementSibling !== seasonalWrapper) {
        popularCategories.insertAdjacentElement('afterend', seasonalWrapper);
      }
      if (patioWrapper && seasonalWrapper && seasonalWrapper.nextElementSibling !== patioWrapper) {
        seasonalWrapper.insertAdjacentElement('afterend', patioWrapper);
      }
      if (stackWrapper && patioWrapper && patioWrapper.nextElementSibling !== stackWrapper) {
        patioWrapper.insertAdjacentElement('afterend', stackWrapper);
      }
    };

    const initialize = (section) => {
      if (!section || section.dataset.rgInitialized === 'true') return;
      section.dataset.rgInitialized = 'true';

      arrangeExperienceOrder(section);
      requestAnimationFrame(() => requestAnimationFrame(() => arrangeExperienceOrder(section)));
      window.setTimeout(() => arrangeExperienceOrder(section), 400);
      window.setTimeout(() => arrangeExperienceOrder(section), 900);

      section.querySelectorAll('[data-rg-experience-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const destination = link.href;
          const shouldDelayNavigation = event.button === 0
            && !event.metaKey
            && !event.ctrlKey
            && !event.shiftKey
            && !event.altKey
            && (!link.target || link.target === '_self')
            && destination;

          if (!shouldDelayNavigation) {
            publish('click', link.dataset.rgExperienceName || '', destination);
            return;
          }

          event.preventDefault();
          let navigationStarted = false;
          const navigate = () => {
            if (navigationStarted) return;
            navigationStarted = true;
            window.location.assign(destination);
          };

          publish('click', link.dataset.rgExperienceName || '', destination, navigate);
          window.setTimeout(navigate, 300);
        });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.dataset.impressionSent === 'true') return;
            entry.target.dataset.impressionSent = 'true';
            publish('impression', entry.target.dataset.rgExperience || '', '');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.3 });

        section.querySelectorAll('[data-rg-experience]').forEach((experience) => {
          observer.observe(experience);
        });
      } else {
        section.querySelectorAll('[data-rg-experience]').forEach((experience) => {
          publish('impression', experience.dataset.rgExperience || '', '');
        });
      }
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-rg-home-experiences]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-seasonal-reasons"]) return;
  try {
    
  (() => {
    const arrange = (section) => {
      const wrapper = section.closest('.shopify-section') || section.parentElement;
      const popular = document.getElementById('shopify-section-1600453141623');
      if (wrapper && popular && popular.nextElementSibling !== wrapper) popular.insertAdjacentElement('afterend', wrapper);
    };
    const initialize = (section) => {
      if (!section || section.dataset.rgSeasonalInitialized === 'true') return;
      section.dataset.rgSeasonalInitialized = 'true';
      arrange(section);
      requestAnimationFrame(() => requestAnimationFrame(() => arrange(section)));
      window.setTimeout(() => arrange(section), 400);
      const publish = (action,name,destination) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event:'homepage_seasonal_reason',homepage_seasonal_action:action,homepage_seasonal_name:name,homepage_seasonal_destination:destination||'',homepage_seasonal_placement:'homepage_above_outdoor_living'});
        if (typeof window.gtag === 'function') window.gtag('event',action === 'click' ? 'homepage_seasonal_reason_click' : 'homepage_seasonal_reason_impression',{homepage_seasonal_name:name,homepage_seasonal_placement:'homepage_above_outdoor_living',link_url:destination||'',non_interaction:action !== 'click'});
      };
      section.querySelectorAll('[data-rg-seasonal-link]').forEach(link => link.addEventListener('click',() => publish('click',link.dataset.rgSeasonalName || 'unknown',link.href)));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { publish('impression','seasonal_reasons',window.location.href); observer.disconnect(); } },{threshold:.25});
        observer.observe(section);
      } else publish('impression','seasonal_reasons',window.location.href);
    };
    const initializeAll = () => document.querySelectorAll('[data-rg-seasonal-reasons]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeAll,{once:true}); else initializeAll();
    document.addEventListener('shopify:section:load',initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patio-moments"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFallHomepage = (root) => {
      const sections = root.matches && root.matches('[data-rg-home-fall]')
        ? [root]
        : root.querySelectorAll('[data-rg-home-fall]');

      sections.forEach((section) => {
        if (section.dataset.rgFallInitialized === 'true') return;
        section.dataset.rgFallInitialized = 'true';
        const viewport = section.querySelector('[data-rg-fall-viewport]');
        const previous = section.querySelector('[data-rg-fall-prev]');
        const next = section.querySelector('[data-rg-fall-next]');
        if (!viewport || !previous || !next) return;
        const scrollAmount = () => {
          const card = viewport.querySelector('.rg-home-fall__card');
          return card ? card.getBoundingClientRect().width + 20 : viewport.clientWidth * 0.8;
        };
        const updateButtons = () => {
          previous.disabled = viewport.scrollLeft <= 3;
          next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 3;
        };
        previous.addEventListener('click', () => viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
        next.addEventListener('click', () => viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
        viewport.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
      });
    };
    initFallHomepage(document);
    document.addEventListener('shopify:section:load', (event) => initFallHomepage(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["private-event-inquiry-form"]) return;
  try {
    
  const privateEventFormId = '97b0c2b4-1bcc-4f49-af86-40595550bd90';
  let privateEventConversionTracked = false;

  const trackPrivateEventConversion = () => {
    if (privateEventConversionTracked) return;
    privateEventConversionTracked = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    // GA4 lead tracking is handled once by snippets/rg-ga4-lead-tracking.liquid.

    window.gtag('event', 'conversion', {
      send_to: 'AW-1009881530/iwkECN7m_OgcELqjxuED'
    });
  };

  window.addEventListener('hs-form-event:on-submission:success', (event) => {
    if (event.detail && event.detail.formId === privateEventFormId) {
      trackPrivateEventConversion();
    }
  });

  window.addEventListener('message', (event) => {
    const isHubSpotOrigin =
      event.origin === 'https://js-na2.hsforms.net' ||
      event.origin === 'https://forms-na2.hsforms.com' ||
      event.origin === 'https://forms.hsforms.com';

    if (
      isHubSpotOrigin &&
      event.data &&
      event.data.type === 'hsFormCallback' &&
      event.data.eventName === 'onFormSubmitted' &&
      (!event.data.id || event.data.id === privateEventFormId)
    ) {
      trackPrivateEventConversion();
    }
  });


  if (!document.querySelector('script[data-private-event-hubspot-form]')) {
    const script = document.createElement('script');
    script.src = 'https://js-na2.hsforms.net/forms/embed/246821686.js';
    script.defer = true;
    script.dataset.privateEventHubspotForm = 'true';
    document.head.appendChild(script);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-christmas-memory-wall"]) return;
  try {
    
  function setupRgcStoryWall(wall){
    if (wall.dataset.rgcReady === 'true') return;
    wall.dataset.rgcReady = 'true';
    const dialog = wall.querySelector('dialog');
    const content = wall.querySelector('[data-rgc-dialog-content]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const storyField = wall.querySelector('[data-rgc-story-text]');
    const titleField = wall.querySelector('[data-rgc-title-input]');
    if (storyField && titleField) {
      let titleEdited = false;
      const suggestTitle = function(value){
        const memory = value.toLowerCase();
        if (/ornament|bauble|keepsake/.test(memory)) return 'A Treasured Ornament';
        if (/carol|song|music|singing/.test(memory)) return 'Christmas in Song';
        if (/christmas tree|fresh cut tree|fir tree|tree lot/.test(memory)) return 'A Tree to Remember';
        if (/light|sparkle|glow|twinkl/.test(memory)) return 'Christmas Lights';
        if (/tradition|every year|each year|annual|family/.test(memory)) return 'A Family Tradition';
        if (/first visit|first time|first walked|first came/.test(memory)) return 'Our First Visit';
        if (/friend|together|husband|wife|daughter|son|mother|father/.test(memory)) return 'Christmas Together';
        return 'A Christmas Memory';
      };
      storyField.addEventListener('input', function(){
        if (!titleEdited) titleField.value = suggestTitle(storyField.value);
      });
      titleField.addEventListener('input', function(){ titleEdited = true; });
      wall.querySelector('.rgc-wall__form')?.addEventListener('submit', function(){
        if (!titleField.value.trim()) titleField.value = suggestTitle(storyField.value);
      });
    }
    const noteColors = ['cream', 'sage', 'gold', 'cranberry'];
    const surpriseNames = ['snow', 'sleigh', 'snowman', 'lights'];
    let lastSurprise = -1;
    let trigger = null;
    wall.querySelectorAll('[data-rgc-open]').forEach(function(button){
      button.addEventListener('click',function(){
        const note = button.closest('.rgc-wall__note');
        const source = note?.querySelector('[data-rgc-story-source]');
        if (!source || !dialog || !content) return;
        trigger = button;
        const selectedColor = noteColors.find(function(color){return note.classList.contains('rgc-wall__note--' + color)}) || 'cream';
        dialog.dataset.rgcTheme = selectedColor;
        delete dialog.dataset.rgcSurprise;
        content.replaceChildren(source.cloneNode(true));
        content.firstElementChild.hidden = false;
        dialog.setAttribute('aria-label', 'Christmas memory: ' + (content.querySelector('h3')?.textContent || 'Guest story'));
        if (wall.dataset.rgcSurprises === 'true' && !reducedMotion.matches) {
          const offset = Math.floor(Math.random() * (surpriseNames.length - 1));
          const selection = lastSurprise < 0 ? Math.floor(Math.random() * surpriseNames.length) : (lastSurprise + 1 + offset) % surpriseNames.length;
          lastSurprise = selection;
          dialog.dataset.rgcSurprise = surpriseNames[selection];
        }
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
    });
    wall.querySelector('[data-rgc-close]')?.addEventListener('click',function(){dialog.close()});
    dialog?.addEventListener('click',function(event){if(event.target === dialog) dialog.close()});
    dialog?.addEventListener('close',function(){delete dialog.dataset.rgcSurprise;if(trigger) trigger.focus()});
  }
  document.querySelectorAll('[data-rgc-story-wall]').forEach(setupRgcStoryWall);
  document.addEventListener('shopify:section:load',function(event){
    event.target.querySelectorAll('[data-rgc-story-wall]').forEach(setupRgcStoryWall);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-private-proposals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-rg-proposal]');
    const pushEvent = (name, params = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
    };

    sections.forEach((section) => {
      const sectionId = section.dataset.sectionId || '';
      const pageHandle = section.dataset.pageHandle || '';
      const storageKey = 'rg_proposal_attribution';
      const params = new URLSearchParams(window.location.search);
      let stored = {};
      try { stored = JSON.parse(window.localStorage.getItem(storageKey) || '{}'); } catch (error) { stored = {}; }
      const current = {
        source: params.get('utm_source') || '',
        medium: params.get('utm_medium') || '',
        campaign: params.get('utm_campaign') || ''
      };
      if ((current.source || current.medium || current.campaign) && !stored.first) stored.first = current;
      if (current.source || current.medium || current.campaign) stored.last = current;
      try { window.localStorage.setItem(storageKey, JSON.stringify(stored)); } catch (error) {}

      section.querySelectorAll('[data-rgp-utm]').forEach((input) => {
        const [touch, field] = input.dataset.rgpUtm.split('_');
        input.value = stored[touch]?.[field] || '';
      });
      section.querySelectorAll('[data-rgp-referrer]').forEach((input) => { input.value = document.referrer || ''; });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            pushEvent('proposal_page_view', { section_id: sectionId, page_handle: pageHandle });
            observer.disconnect();
          }
        }, { threshold: 0.2 });
        observer.observe(section);
      } else {
        pushEvent('proposal_page_view', { section_id: sectionId, page_handle: pageHandle });
      }

      section.querySelectorAll('[data-proposal-event]').forEach((element) => {
        element.addEventListener('click', () => pushEvent(element.dataset.proposalEvent, {
          section_id: sectionId,
          page_handle: pageHandle,
          link_url: element.getAttribute('href') || '',
          link_text: element.textContent.trim()
        }));
      });

      const form = section.querySelector('.rgp-form');
      if (form) {
        let started = false;
        form.addEventListener('input', () => {
          if (started) return;
          started = true;
          pushEvent('proposal_inquiry_start', { section_id: sectionId, page_handle: pageHandle });
        }, { once: true });
      }


      const proposalFormId = '97b0c2b4-1bcc-4f49-af86-40595550bd90';
      const buildProposalFields = (values) => {
        const fullName = values.name.trim();
        const parts = fullName.split(/\s+/);
        const emailSafe = ['email_safe', 'email_before_call'].includes(values.safeMethod);
        const dateMs = Date.parse(values.date + 'T00:00:00Z');
        if (!/^\d{4}-\d{2}-\d{2}$/.test(values.date) || !Number.isFinite(dateMs) || new Date(dateMs).toISOString().slice(0, 10) !== values.date) throw new Error('Invalid date');
        const details = [
          '[RG_PROPOSAL_V1] safe_email=' + (emailSafe ? 'yes' : 'no'),
          'Inquiry type: Marriage proposal experience at Rogers Gardens',
          'Safe contact method: ' + values.safeLabel,
          'Name: ' + fullName,
          'Preferred proposal date: ' + values.date,
          'Preferred evening window: ' + values.time,
          'Proposal direction: ' + values.experience,
          'Farmhouse dinner plan: ' + (values.dinner || 'Not provided'),
          'Story and vision: ' + values.story,
          'Ideas and possibilities: ' + (values.extras || 'Not provided'),
          'The proposal experience is separate from large private-event minimums. A Farmhouse dinner preference does not change this proposal inquiry into a restaurant event.',
          'Source: https://www.rogersgardens.com/pages/marriage-proposals-orange-county'
        ].join('\n');
        return [
          ['0-1/firstname', parts.shift() || ''],
          ['0-1/lastname', parts.join(' ')],
          ['0-1/email', values.email.trim()],
          ['0-1/phone', (() => {
            const phone = values.phone.trim();
            if (phone.startsWith('+')) return phone;
            const digits = phone.replace(/\D/g, '');
            if (digits.length === 10) return '+1' + digits;
            if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
            return phone;
          })()],
          ['0-1/event_type', 'Other Event'],
          ['0-1/event_space_preference', 'Rogers Gardens'],
          ['0-1/preferred_event_date', String(dateMs)],
          ['0-1/number_of_guests_at_event', ''],
          ['0-1/estimated_event_budget', ''],
          ['0-1/event_details', details]
        ];
      };
      const preflight = section.querySelector('[data-rgp-preflight]');
      const review = section.querySelector('[data-rgp-review]');
      const frame = section.querySelector('[data-rgp-hubspot-frame]');
      const reviewStatus = section.querySelector('[data-rgp-review-status]');
      const continueButton = section.querySelector('[data-rgp-continue]');
      let hubspotForm = null;
      let pendingFields = null;
      let submitted = false;
      let loadingTimer;
      let applying = false;
      const applyFields = async () => {
        if (!hubspotForm || !pendingFields || applying || submitted) return;
        applying = true;
        try {
          for (const [name, value] of pendingFields) await hubspotForm.setFieldValue(name, value);
          const details = await hubspotForm.getFieldValue('0-1/event_details');
          if (details !== pendingFields.find(([name]) => name === '0-1/event_details')[1]) throw new Error('Details not applied');
          clearTimeout(loadingTimer);
          frame.hidden = false;
          reviewStatus.textContent = reviewStatus.dataset.ready;
        } catch (error) {
          frame.hidden = true;
          reviewStatus.textContent = reviewStatus.dataset.error;
        } finally {
          applying = false;
          continueButton.disabled = false;
        }
      };
      const isProposalForm = (event) => event.detail && event.detail.formId === proposalFormId;
      window.addEventListener('hs-form-event:on-ready', (event) => {
        if (!isProposalForm(event)) return;
        hubspotForm = window.HubSpotFormsV4.getFormFromEvent(event);
        applyFields();
      });
      window.addEventListener('hs-form-event:on-submission:success', (event) => {
        if (!isProposalForm(event) || !pendingFields || submitted) return;
        submitted = true;
        preflight.hidden = true;
        review.hidden = true;
        const success = section.querySelector('[data-proposal-form-success]');
        success.hidden = false;
        success.focus();
        pushEvent('proposal_inquiry_submit_success', { section_id: sectionId, page_handle: pageHandle });
      });
      window.addEventListener('hs-form-event:on-submission:failed', (event) => {
        if (isProposalForm(event) && pendingFields) reviewStatus.textContent = reviewStatus.dataset.error;
      });
      if (preflight && continueButton) {
        preflight.addEventListener('submit', (event) => event.preventDefault());
        continueButton.disabled = false;
        continueButton.addEventListener('click', () => {
          if (submitted || applying || !preflight.reportValidity()) return;
          const value = (name) => preflight.elements.namedItem('contact[' + name + ']').value;
          const safe = preflight.elements.namedItem('contact[Safe contact method]');
          pendingFields = buildProposalFields({
            name: value('Name'), email: value('email'), phone: value('phone'),
            safeMethod: safe.value, safeLabel: safe.options[safe.selectedIndex].text,
            date: value('Preferred proposal date'), time: value('Preferred proposal time'),
            experience: value('Proposal direction'), dinner: value('Farmhouse dinner plan'),
            story: value('Your story and vision'), extras: value('Possibilities of interest')
          });
          continueButton.disabled = true;
          preflight.hidden = true;
          review.hidden = false;
          frame.hidden = true;
          reviewStatus.textContent = reviewStatus.dataset.loading;
          section.querySelector('[data-rgp-review-title]').focus();
          clearTimeout(loadingTimer);
          loadingTimer = setTimeout(() => {
            if (!frame.hidden || submitted) return;
            reviewStatus.textContent = reviewStatus.dataset.error;
            continueButton.disabled = false;
          }, 15000);
          if (hubspotForm) {
            applyFields();
          } else if (!document.querySelector('script[data-rgp-hubspot-loader]')) {
            const script = document.createElement('script');
            script.src = 'https://js-na2.hsforms.net/forms/embed/246821686.js';
            script.defer = true;
            script.dataset.rgpHubspotLoader = 'true';
            script.onerror = () => {
              clearTimeout(loadingTimer);
              reviewStatus.textContent = reviewStatus.dataset.error;
              continueButton.disabled = false;
            };
            document.head.appendChild(script);
          }
        });
        section.querySelector('[data-rgp-back]').addEventListener('click', () => {
          if (submitted) return;
          clearTimeout(loadingTimer);
          review.hidden = true;
          preflight.hidden = false;
          continueButton.disabled = false;
          continueButton.focus();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
